import users from "./users.json";
import allExperimentalFeatures from "./experimentalFeatures.json";

const STORAGE_KEY = "PORTAL_DEVELOPMENT_USER";

const getUsers = () => users;

const getCurrentUser = () => {
  const storageUpn = localStorage.getItem(STORAGE_KEY) || "";
  const foundUser = users.find((user) => user.upn === storageUpn);
  return foundUser || users.find((user) => user.upn === "")!; // fallback to unauthenticated user
};

const setCurrentUser = (upn: string | null) => {
  if (upn) {
    localStorage.setItem(STORAGE_KEY, upn);
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }

  window.location.reload();
};

export const getAllExperimentalFeatures = async () => {
  await new Promise((resolve) => {
    resolve(allExperimentalFeatures);
  });
}

export default {
  getUsers,
  getCurrentUser,
  setCurrentUser,
};
